import React from "react";
import "../HTMate/HTMate.scss";

const AboutUs = () => {
  return (
    <div
      className="data-container"
      // style={{
      //   backgroundImage: "url('../../assets/images/backgrounds/2.jpg')",
      // }}
    >
      <div className="textitem">
        <h3>About Us: Empowering Healthcare through Interoperability</h3>
        <p>
          At Hlthtek, we believe in a future where healthcare is accessible,
          affordable, and personalized for everyone. We're a company built on a
          foundation of technology expertise and medical knowledge, driven by a
          shared vision to transform healthcare in India.
        </p>
        <p>
          Our mission is to revolutionize healthcare delivery through seamless
          data interoperability. We leverage the power of the Ayushman Bharat
          Digital Mission (ABDM) launched by the National Health Authority
          (NHA), India, to create a secure and connected healthcare ecosystem.
          Our cutting-edge digital healthcare solutions enable the safe and
          efficient exchange of health data, empowering patients, doctors, and
          healthcare providers alike.
        </p>

        <div className="textitem">
          <h5>Why Hlthtek?</h5>
          <ul>
            <li>
              <strong>Harnessing the Power of Interoperability:</strong> We are
              committed to building a robust and secure digital healthcare
              infrastructure that seamlessly connects patients, hospitals, and
              healthcare professionals. This enables real-time access to medical
              records, fostering better-informed decisions and improved patient
              care.
            </li>
            <li>
              <strong>Empowering Patients:</strong> We put patients at the
              center of our solutions, giving them greater control over their
              health data and facilitating convenient access to healthcare
              services.
            </li>
            <li>
              <strong>Improving Efficiency:</strong> Our solutions streamline
              healthcare processes, reducing administrative burden and enabling
              healthcare providers to focus on delivering quality patient care.
            </li>
            <li>
              <strong>Driving Affordability:</strong> We believe that everyone
              deserves access to affordable and quality healthcare. Our
              solutions aim to reduce costs associated with healthcare delivery
              and make quality care more accessible to all.
            </li>
          </ul>
        </div>

        <div className="textitem">
          <h5>Our Team:</h5>
          <p>
            Hlthtek is a collaborative venture of seasoned technology experts
            and dedicated doctors. Our diverse and passionate team brings
            together the best of both worlds - technological innovation and
            medical expertise - to create impactful solutions that truly benefit
            patients and the entire healthcare community.
          </p>
        </div>

        <p>
          <strong>
            Join us on our journey to build a more accessible, affordable, and
            efficient healthcare future in India.
          </strong>
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
